<template>
    <component :is="tag"
               :class="$style.VLinkUnderline"
               :to="props.to"
               :href="props.href"
               :target="props.target"
               :rel="props.rel"
               @mouseenter="handleMouseEnter"
               @mouseleave="handleMouseLeave"
               @click="handleClick"
    >
        <WBIcon v-if="icon && iconPosition === 'left'"
                class="icon"
                :name="icon"
                :class="[$style.icon, $style._left]"
        />
        <span :class="$style.label"
              class="label"
        >
            <slot />
        </span>
        <WBIcon v-if="icon && iconPosition === 'right'"
                class="icon"
                :name="icon"
                :class="[$style.icon, $style._right]"
        />
    </component>
</template>

<script
    setup
    lang="ts"
>
    import type { VLinkUnderlineProps, WBLinkUnderlineEmits } from './types'

    const props = defineProps<VLinkUnderlineProps>()
    const emits = defineEmits<WBLinkUnderlineEmits>()

    const tag = computed(() => {
        if (props.to || props.href) {
            return resolveComponent('nuxt-link')
        }

        if (props.tag) {
            return props.tag
        }

        return 'div'
    })

    const handleMouseLeave = () => {
        emits('mouseleave')
    }

    const handleMouseEnter = () => {
        emits('mouseenter')
    }

    const handleClick = (e: Event) => {
        if (!props.href || !props.to) {
            return
        }

        emits('click', e)
    }
</script>

<style
    lang="scss"
    module
>
    .VLinkUnderline {
        display: flex;
        align-items: center;
        cursor: pointer;

        @include hover {
            .label {
                &:before {
                    transform: scaleX(1);
                    transform-origin: left;
                }
            }
        }
    }

    .label {
        position: relative;
        display: inline-block;
        transition: color $default-transition;

        &:before {
            content: "";
            position: absolute;
            top: 100%;
            left: 0;
            width: 100%;
            height: .1rem;
            background-color: currentcolor;
            transform: scaleX(0);
            transform-origin: right;
            transition: transform $default-transition;
        }
    }

    .icon {
        width: 2.4rem;
        height: 2.4rem;
        fill: currentcolor;

        &._right {
            margin-left: 1rem;
        }

        &._left {
            margin-right: 1rem;
        }
    }
</style>
